import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Field } from 'formik'

export const SendNotificationWrapper = styled.div`
  padding-top: 1.5625rem;
  color: ${themeGet('colors.backgroundBody')};
  border-top: 0.0938rem solid ${themeGet('colors.borderTable')};
`

export const Header = styled.p`
  color: ${themeGet('secondStepBlueColor')};
  font-size: 1.063rem;
  margin: 0;
  font-family: ${themeGet('sharpSlabExtrabold')};
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.125rem;
  p {
    font-family: ${themeGet('headerFontFamily')};
  }

  ${themeGet('breakpoints.tablet')} {
    margin-bottom: 0.125rem;
  }
`

export const Body = styled.p`
  color: #444444;
  font-family: ${themeGet('fontFamily')};
  font-size: 0.938rem;
  letter-spacing: 0;
  line-height: 1.313rem;
  margin: 0.6875rem 0rem 0rem;
`

export const RegIcon = styled.span`
  position: relative;
  top: -0.4375rem;
  font-size: 55%;
`

export const FaqLink = styled.a`
  text-decoration: none;
  font-family: ${themeGet('fontFamilySemibold')};
  color: ${themeGet('colors.blue')};
  &:hover {
    color: ${themeGet('colors.secondStepBlue')};
  }
`

export const RadioGroup = styled.div`
  display: flex;
  justify-content: flex-start;
  color: ${themeGet('colors.darkGray')};
  font-family: ${themeGet('fontFamilySemibold')};
  margin-top: 1.125rem;

  label:first-child {
    margin-right: 1.25rem;
  }
`

export const RadioField = styled(Field)`
  accent-color: ${themeGet('colors.blue')};
  margin-right: 0.4375rem;
  cursor: pointer;
`

interface RadioLabelProps {
  disabled?: boolean
}

export const RadioLabel = styled.label<RadioLabelProps>`
  font-family: ${themeGet('textFontFamily')};
  margin-top: -0.25rem;
  opacity: ${props => (props.disabled ? '60%' : '100%')};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};

  color: #1f1f1f;
  letter-spacing: 0;
  line-height: 20px;

  & input {
    margin-right: 0.4375rem;
  }
`
